import { colorsV2 } from '@doltech/ui/lib/figma/colors-v2';
import { ReadingViewModeEnum } from '@doltech/utils/lib/constants';
import cl from 'classnames';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import styled from 'styled-components';

import { DoTestReadingMobileLayout } from '../layouts/DoTestReadingMobileLayout';
import { ReadingTestSubmissionProps } from '../layouts/ReadingTestSubmission';
import { useTestSubmissionStore } from '../model/test-submissions.hook';
import { MobileEditor } from './MobileEditor/EditorMobile';
import { QuestionContentMobile } from './Question/QuestionContentMobile';

const BodyWrapper = styled.div`
  border-top: 1px solid ${colorsV2.black5};
  overflow: auto;
`;
const PassageWrapper = styled.div`
  background: ${colorsV2.white100} !important;
`;
export const ReadingTestSubmissionMobile = observer((props: ReadingTestSubmissionProps) => {
  const { onSubmitWithEvents, onQuit } = props;
  const testSubmissionStore = useTestSubmissionStore();
  const currentSection = testSubmissionStore.currentTestSection;
  const currentViewMode = currentSection?.currentViewMode;

  const toggleViewMode = () => {
    currentSection.updateCurrentViewMode(
      currentViewMode === ReadingViewModeEnum.PASSAGE
        ? ReadingViewModeEnum.QUESTION
        : ReadingViewModeEnum.PASSAGE
    );
  };

  const switchToPassageView = () => {
    if (currentViewMode === ReadingViewModeEnum.QUESTION) {
      toggleViewMode();
      currentSection.updateCurrentViewMode(ReadingViewModeEnum.QUESTION);
    }
  };

  return (
    <DoTestReadingMobileLayout
      onQuit={onQuit}
      onToggleViewMode={toggleViewMode}
      onSubmitWithEvents={onSubmitWithEvents}
    >
      <PassageWrapper
        id="passage-container"
        className={cl({ visible: currentViewMode === ReadingViewModeEnum.PASSAGE })}
      >
        <MobileEditor
          key={testSubmissionStore.currentSectionIndex.toString()}
          value={currentSection?.getPassage()}
        />
      </PassageWrapper>
      <BodyWrapper
        id="body-container"
        className={cl({ visible: currentViewMode === ReadingViewModeEnum.QUESTION })}
      >
        <QuestionContentMobile onNavigation={switchToPassageView} onSubmit={onSubmitWithEvents} />
      </BodyWrapper>
    </DoTestReadingMobileLayout>
  );
});
